export const isAuthPage = (pathname: string): boolean => {
	return !!pathname?.match(/auth/)?.length
}

export const isAuthRedirectPage = (pathname: string): boolean => {
	return !!pathname?.match(/auth-redirect/)?.length
}

export const isAuthUserInfoPage = (pathname: string): boolean => {
	return !!pathname?.match(/auth(\/?)$/)?.length
}

export const isProfileCompletionRoute = (pathname: string): boolean => {
	return pathname === '/auth' || pathname === '/auth/'
}

export const isCreateNewRequest = (pathname: string): boolean => {
	return !!pathname?.match(/.*\/requests\/create\/[^\/]+/)?.length
}

export const isCreateRequestPage = (pathname: string): boolean => {
	return !!pathname?.match(/.*\/requests\/create$|.*\/requests\/create\/$/)
		?.length
}

export const isPaymentPage = (pathname: string): boolean => {
	return !!pathname?.match(/auth\/payment\/?$/)?.length
}

export const usesHomepageLayout = (pathname: string): boolean => {
	if (!isAuthPage(pathname) || isCreateRequestPage(pathname)) {
		return true
	}

	return (
		!isCreateNewRequest(pathname) &&
		!isAuthRedirectPage(pathname) &&
		!isAuthUserInfoPage(pathname) &&
		!isPaymentPage(pathname)
	)
}
